/**
 * Visites de page (bouton ? → « Visite de cette page ») : une par route, rien en dehors.
 * Déplacé d'App.js le 05/10/2026 : plus de repli vers la visite générale sur une page sans visite.
 * Les étapes portant `permission` sont filtrées au lancement (VisiteController → moteur.filtrerEtapes).
 * Les repères data-tour de chaque visite sont vérifiés par tours/__tests__/reperes.test.js.
 */
import portalTour from './portal';
import ticketingTourSteps from './ticketing';
import assistantTourSteps from './assistant';
import vaultTourSteps from './vault';
import { computersTour as parcComputersTour, sauvegardesTour as parcSauvegardesTour } from './parc';

// '/ticketing/dashboard' retiré : TicketDashboard ne porte aucun repère, ses étapes n'éclairaient rien.
export const TOUR_MAP = {
  '/dashboard': { steps: portalTour, id: 'portal' },
  '/tickets': { steps: ticketingTourSteps, id: 'ticketing_v3' },
  '/assistant': { steps: assistantTourSteps, id: 'assistant' },
  '/vault': { steps: vaultTourSteps, id: 'vault' },
  '/parc/ordinateurs': { steps: parcComputersTour, id: 'parc' },
  '/parc/sauvegardes': { steps: parcSauvegardesTour, id: 'parc_sauvegardes' },
};

export function visitePourRoute(pathname) {
  return TOUR_MAP[pathname] || null;
}
